import React from 'react'
import numeral from 'numeral'

import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { compose, withState, lifecycle, withHandlers } from 'recompose'
import { FormattedMessage } from 'react-intl'

//import { fetchingState } from '../helpers/hocs.js'
//import { getActions, getCount } from '../store/reducers/actions/list.js'//get
import { getActionsList } from '../selectors/actions.js'
import { fetchingState } from '../helpers/hocs.js'
import { getCount as getTotal, getActions } from '../store/reducers/actions/list.js'
import { getExternalPartnersList } from '../selectors/externalpartners.js'
import { getExternalPartners } from '../store/reducers/externalpartners/list.js'

import Link from './../components/Link'
import Categories from './Categories'
import Button from '../components/Button'
import Person from './../components/Person'
import Loader from './../components/OverlayLoader'
import Select from './../components/Select'
import { forEach } from 'ramda'

const categoryClick = handler => name => {
  handler(name)
}

const ActionsPage = ({ items = [], count = 0, length = 0, fetching, loadMore,
  externalPartners = {}, data = {}, tmpData, setData, peoceed, submit, externalPartnersList = [], countExtPartners = 0,}) => {//fetching = {}, get, setCategory, category
  if (externalPartnersList.items) 
  externalPartnersList.items.forEach(partner => {
      externalPartners[partner._id] = partner.title;
    })

  let dates = {"current" : "действующие",
            "closed" : "закрытые"}//сроки
  console.log('items', items);
  let state = {};
  return (
    <div className='Actions'>
      <div className='Container Container_light'>
        <div className='Actions__header'>
          Благотворительные акции
        </div>
        <div className='Actions__select'>
        <Select class=" Select-one" value={tmpData.topic} items={externalPartners} name="Бренды" onSubmit={peoceed.bind(this, 'topic')} />{/*tmpData.topic - выбранное значение*/}
        <Select class=" Select-two" value={tmpData.time} items={dates} name="Сроки" onSubmit={peoceed.bind(this, 'time')} />{/**/}
        </div>
        {
          items.map((action, i) => {
            let ePartnersIds = (action.externalpartnersId) ? action.externalpartnersId.map(ePartner => ePartner._id) : [];
            let time = true;
            if (tmpData.time) {
              switch (tmpData.time) {
                //case "oncoming" : time = (new Date(action.startDate) > new Date()) ? true : false; break;
                case "current" : time = (new Date(action.startDate) < new Date() && new Date(action.closeDate) > new Date()) ? true : false; break;
                case "closed" : time = (new Date(action.closeDate) < new Date()) ? true : false; break;
              }
            }
			//при наличие alias будет включен в ссылку на лот, если нет остается id
			let alias = action._id
			if(action.alias)
            {
              alias = action.alias
            }
            return (
              ((!tmpData.topic || tmpData.topic && ePartnersIds.includes(tmpData.topic)) && (time) && (action.title !== 'Помогаю! Врачам бороться с COVID-19'))
              && <Link className='ActionsTable' to={'/actions/' + alias} key={action._id} >{/*onClick={onClick || null} */}
                <div className='ActionsTable__inner'>
                  <img className='ActionsTable__img' src={action.image} alt={action.name} />{/*onLoad={handleLoad} */}
                  <span className='ActionsTable__name SubHead'>{/*'Lot__name_bottom */}{action.title}</span>
                  <span className='ActionsTable__price Small'>Собрали: {action.externalPaymentsStats ? 
                  ((numeral(action.externalPaymentsStats.sum).format('0,0') == 0) ? 'coming soon' : (numeral(action.externalPaymentsStats.sum).format('0,0') + ' ₽'))
                   : "coming soon"}</span>
                  <span className='ActionsTable__price2 Small'>Охват: {action.externalPaymentsStats ? 
                  ((numeral(action.externalPaymentsStats.personsCount).format('0,0') == 0) ? 'coming soon' : (action.externalPaymentsStats.personsCount + ' людей'))
                  : "coming soon"}</span>
                  <div className='ActionsTable__gradient' />
                </div>
              </Link>
            )
          }
          )
        }
      </div>
    </div>
  )
}

const mapStateToProps = state => {
  //console.log('state',state);
  return ({
    ...getActionsList(state),
    /*...getExternalPartnersList(state),*/
    externalPartnersList: getExternalPartnersList(state),
    currentLocale: state.intl.locale//'ru' - always?
  })
}

const mapDispatchToProps = dispatch => bindActionCreators({ getTotal, getActions, getExternalPartners }, dispatch)
const mergeProps = (state, { getActions, getTotal, getExternalPartners }, { fetchingWrap, ...props }) => ({
  ...props,
  ...state,
  getTotal,
  getActions: (offset, noLoader) => noLoader ? getActions(offset) : fetchingWrap(getActions.bind(this, offset)),
  getExternalPartners: (offset, noLoader) => noLoader ? getExternalPartners(offset) : fetchingWrap(getExternalPartners.bind(this, offset))
})


export default compose(
  fetchingState(),
  connect(mapStateToProps, mapDispatchToProps, mergeProps),
  withState('data', 'setData', {}),
  withState('tmpData', 'setTmpData', {}),
  withState('success', 'setSuccess', null),
  withHandlers({
    get: ({ get, fetchingWrap }) => () => fetchingWrap(get.bind(this), 'info'),
    setData: ({ setTmpData, tmpData }) => field => e => {
      tmpData[field] = e
      setTmpData(tmpData)
    },
    clearData: ({ setData }) => () => {
      setData({})
    },
    loadMore: ({ length = 0, getActions, fetching }) => async e => {
      e && e.preventDefault()
      if (fetching) return
      await getActions(length)
    },
    peoceed: ({ setData, data, setTmpData, tmpData }) => (field, e) => {/////////////
      //console.log(setData, data, setTmpData, tmpData)
      e && e.preventDefault && e.preventDefault()
      data[field] = //field === 'topic' ?
       e //: tmpData[field]
      setData(data)
      //if (field === 'topic') //
        setTmpData({ ...tmpData, [field]: e })
    },
    /*submit: ({ send, info, tmpData, data, setSuccess, fetchingWrap }) => async e => {
      e && e.preventDefault()
      setSuccess(null)
      data = { ...info, ...tmpData, topic: data.topic }
      const result = await fetchingWrap(send.bind(this, data), 'send')
      setSuccess(result === 200)
    }*/
  }),
  lifecycle({
    componentDidMount() {
      this.props.getActions(0, false)
      this.props.getTotal()
      this.props.getExternalPartners(0, false)
    }
  })
)(ActionsPage)




// WEBPACK FOOTER //
// ./src/containers/Actions.jsx